import axios from 'axios'
import store from '@/store'

const API_BASE = 'https://residencial-services.intrare.app/board-directive'

export function extractApiErrorMessage (error) {
  const data = error && error.response && error.response.data
  if (!data) return 'Ocurrió un error al conectar con el servidor'
  if (typeof data === 'string') return data
  if (data.detail) return data.detail

  const messages = []
  const flatten = (obj, prefix) => {
    Object.keys(obj).forEach(key => {
      const val = obj[key]
      const label = prefix ? `${prefix}.${key}` : key
      if (Array.isArray(val)) {
        val.forEach(v => messages.push(`${label}: ${v}`))
      } else if (val && typeof val === 'object') {
        flatten(val, label)
      } else {
        messages.push(`${label}: ${val}`)
      }
    })
  }
  flatten(data, '')
  return messages.join(' | ') || 'Ocurrió un error al procesar la solicitud'
}

export default {
  async getSolicitudes (page = 1, pageSize = 10) {
    const url = `${API_BASE}/solicitudes/?page=${page}&page_size=${pageSize}`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      if (Array.isArray(response.data)) {
        return response.data
      }
      return response.data.results || []
    } catch (error) {
      console.error('Error fetching solicitudes:', error)
      throw error
    }
  },

  async getSolicitud (solicitudId) {
    const url = `${API_BASE}/solicitudes/${solicitudId}/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching solicitud:', error)
      throw error
    }
  },

  async cambiarEstado (solicitudId, estado, comentario = '') {
    const url = `${API_BASE}/solicitudes/${solicitudId}/`

    try {
      const response = await axios.patch(url, {
        estado: estado,
        comentario: comentario
      }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error updating solicitud:', error)
      throw error
    }
  },

  async agregarComentario (solicitudId, texto, tipo = 'comentario') {
    const url = `${API_BASE}/solicitudes/${solicitudId}/agregar-comentario/`

    try {
      const response = await axios.post(url, {
        texto: texto,
        tipo: tipo
      }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error adding comment:', error)
      throw error
    }
  }
}
